import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import {
  Typography,
  TextField,
  Button,
  MenuItem,
  Modal,
  Menu,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Checkbox,
  Collapse,
  IconButton,
  Box,
  Grid,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Swal from "sweetalert2";
import ClearIcon from "@mui/icons-material/Clear";
import {
  uploadProductFile,
  getJobWithProducts,
  deleteJobs,
  getAllProducts,
  importProduct,
} from "../Service";
import moment from "moment";
import LoadingButton from "@mui/lab/LoadingButton";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import SettingsIcon from "@mui/icons-material/Settings";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import styled from "@emotion/styled";
import { addLog } from "../../utils/addLog";
import CircularProgress from "@mui/material/CircularProgress";
import { exportExcelCustomHeader } from "../../utils/exportExcelCustomHeader";
import { useTranslation } from "react-i18next";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { dataAccessPermission } from "../../utils/dataAccessPermission";
import { signOut } from "../../utils/signOut";

const styleGrayBtn = {
  backgroundColor: "#5C5C5C",
  color: "#FFFFFF",
  borderRadius: "10px",
  height: "45px",
  textTransform: "none",
  width: "100px",
};

const StyledMenu = styled(Menu, {
  shouldForwardProp: (prop) => prop !== "borderRadius",
})(({ theme }) => ({
  borderRadius: "10px", // Adjust the value as needed
  "& .MuiPaper-root": {
    // Target the paper element within Menu
    borderRadius: "inherit", // Inherit the border radius from StyledMenu
  },
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  // backgroundColor: "lightblue", // Adjust as desired
  color: "#5C5C5C", // Adjust as desired
  // padding: theme.spacing(1), // Optional: Adjust padding
  // borderRadius: "8px", // Optional: Add rounded corners (from previous example)
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};

const styleModaldelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: 200,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 3,
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box
      sx={{
        flexShrink: 0,
        ml: 2.5,
      }}
    >
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function JobWithProduct() {
  const [t, i18n] = useTranslation("global");

  const [userData, setUserData] = React.useState(
    JSON.parse(sessionStorage.getItem("authUserData"))
  );

  const [dataProduct, setDataProduct] = useState([]);

  // New page ------------------------------------
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("GroupID");
  const [selected, setSelected] = useState([]);
  const [openRow, setOpenRow] = useState(null);

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelect = (id) => {
    // const handleSelect = (id, urole) => {
    // console.log(`urole:`, urole);
    const newSelected = selected.includes(id)
      ? selected.filter((item) => item !== id)
      : [...selected, id];
    setSelected(newSelected);
  };

  const handleRowToggle = (id) => {
    setOpenRow(openRow === id ? null : id);
  };

  const sortedData = [...dataProduct].sort((a, b) => {
    if (order === "asc") {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    } else {
      return a[orderBy] > b[orderBy] ? -1 : 1;
    }
  });

  // End New page --------------------------------

  const headCells = [
    {
      id: "code",
      numeric: false,
      disablePadding: true,
      sortKey: "GroupID",
      label: t("product.table.header.code"),
    },
    {
      id: "job",
      numeric: false,
      disablePadding: true,
      sortKey: "GroupName",
      label: t("product.table.header.job"),
    },
    {
      id: "uom",
      numeric: false,
      disablePadding: false,
      sortKey: null,
      label: t("product.table.header.uom"),
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      sortKey: null,
      label: t("product.table.header.description"),
    },
    {
      id: "uprice",
      numeric: true,
      disablePadding: false,
      sortKey: "LaborCost",
      label: t("product.table.header.job_labor_price"),
    },
    {
      id: "action",
      numeric: false,
      disablePadding: false,
      sortKey: null,
      label: t("genboq.table.header.action"),
    },
  ];

  const subHeadCells = [
    {
      id: "code",
      numeric: false,
      disablePadding: true,
      label: t("product.table.header.code"),
    },
    {
      id: "product",
      numeric: false,
      disablePadding: true,
      label: t("product.table.header.product"),
    },
    {
      id: "uom",
      numeric: false,
      disablePadding: false,
      label: t("product.table.header.uom"),
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: t("product.table.header.description"),
    },
    {
      id: "model",
      numeric: false,
      disablePadding: false,
      label: t("product.table.header.model"),
    },
    {
      id: "matprice",
      numeric: true,
      disablePadding: false,
      label: t("product.table.header.labor_price"),
    },
    {
      id: "uprice",
      numeric: true,
      disablePadding: false,
      // label: "Unit Price",
      label: t("product.table.header.price"),
    },
    {
      id: "PriceHomepro",
      numeric: true,
      disablePadding: false,
      label: t("product.table.header.priceHome"),
      align: "center",
    },
    {
      id: "PriceThaiWat",
      numeric: true,
      disablePadding: false,
      label: t("product.table.header.priceThai"),
      align: "center",
    },
    {
      id: "PriceBoon",
      numeric: true,
      disablePadding: false,
      label: t("product.table.header.priceBoon"),
      align: "center",
    },
    {
      id: "Other",
      numeric: true,
      disablePadding: false,
      label: t("product.table.header.priceOth"),
      align: "center",
    },
    {
      id: "reference",
      numeric: false,
      disablePadding: false,
      label: t("product.table.header.ref"),
    },
    {
      id: "searchon",
      numeric: false,
      disablePadding: false,
      label: t("product.table.header.last"),
    },
  ];

  const styles = {
    BtnIcon: {
      width: 32,
      height: 32,
    },
  };
  //
  const [anchorElAction, setAnchorElAction] = React.useState(null);
  const handleOpenActionMenu = (event) => {
    setAnchorElAction(event.currentTarget);
  };
  const handleCloseActionMenu = () => {
    setAnchorElAction(null);
  };
  // Selected row
  const [anchorElActionSelected, setAnchorElActionSelected] =
    React.useState(null);
  const handleOpenActionMenuSelected = (event) => {
    setAnchorElActionSelected(event.currentTarget);
  };
  const handleCloseActionMenuSelected = () => {
    setAnchorElActionSelected(null);
  };

  const fileRef = useRef(null);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchInput, setSearchInput] = useState("");

  const [errorMsg, setErrorMsg] = useState("");
  const [sumErrorMsg, setSumErrorMsg] = useState("");

  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    handleCloseActionMenu();
    setloadingbutton(false);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setErrorMsg("");
  };

  const handleClearSearchProduct = () => {
    setSearchInput("");
    setSelected([]); // Clear selected row
  };

  // Export all
  const [openConfirmExportAll, setOpenConfirmExportAll] = useState(false);
  const handleOpenConfirmExportAll = () => {
    handleCloseActionMenu();
    setLoadingBtnExportAll(false);
    setOpenConfirmExportAll(true);
  };
  const handleCloseConfirmExportAll = () => {
    setOpenConfirmExportAll(false);
    setErrorMsg("");
  };
  const [loadingBtnExportAll, setLoadingBtnExportAll] = useState(false);

  // Export selected row
  const [openConfirmExport, setOpenConfirmExport] = useState(false);
  const handleOpenConfirmExport = () => {
    handleCloseActionMenuSelected();
    setLoadingBtnExport(false);
    setOpenConfirmExport(true);
  };
  const handleCloseConfirmExport = () => {
    setOpenConfirmExport(false);
    setErrorMsg("");
  };
  const [loadingBtnExport, setLoadingBtnExport] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [loadingbutton, setloadingbutton] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    setOpenModal(false);
    handleRemove();
    setSumErrorMsg("");
  };

  const [openModalMultidelete, setOpenModalMultidelete] = useState(false);
  const [openModaldelete, setOpenModaldelete] = useState(false);
  const [loadingbuttondelete, setloadingbuttondelete] = useState(false);
  const handleOpenModaldelete = () => {
    setOpenModaldelete(true);
  };
  const handleCloseModaldelete = () => setOpenModaldelete(false);

  const handleOpenModalMultidelete = () => {
    handleCloseActionMenuSelected();
    setOpenModalMultidelete(true);
  };
  const handleCloseModalMultidelete = () => setOpenModalMultidelete(false);

  const handleClickModal = () => {
    setloadingbutton(true);
    uploadExcelFile();
    addLog("Product", "Import", null);
  };
  const actions = [
    {
      // name: "Import",
      name: t("product.button.import"),
      event: handleOpen,
      icon: <FileDownloadOutlinedIcon />,
    },
    {
      // name: "Export all",
      name: t("product.button.exportAll"),
      event: handleOpenConfirmExportAll,
      icon: <FileUploadOutlinedIcon />,
    },
  ];
  const actionsSelected = [
    {
      // name: "Export",
      name: t("product.button.export"),
      event: handleOpenConfirmExport,
      icon: <FileUploadOutlinedIcon />,
    },
    {
      // name: "Delete",
      name: t("common.button.del"),
      event: handleOpenModalMultidelete,
      icon: <DeleteIcon />,
    },
  ];

  const handleClickModalMultidelete = () => {
    setloadingbuttondelete(true);
    deleteMultiJobs();
    addLog("Job", "Delete", null);
  };

  const handleClickModalExportAll = () => {
    setLoadingBtnExportAll(true);
    exportAll();
    addLog("Product", "Export all", null);
  };

  const handleClickModalExport = () => {
    setLoadingBtnExport(true);
    exportSelected();
    addLog("Product", "Export selected", null);
  };

  const deleteMultiJobs = () => {
    const role = dataAccessPermission("OWNER");

    var dataForm = {
      ID: selected,
      UserRole: role,
    };

    deleteJobs(dataForm).then((res) => {
      if (res && res.status === 200 && res.data.success === true) {
        handleCloseModalMultidelete();
        setSelected([]);
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Detete Jobs successfully",
          showConfirmButton: false,
          timer: 5000,
        });
        setPage(0);
        getData(0, rowsPerPage); // Reload data
      } else if (res.status === 401) {
        handleCloseModalMultidelete();
        signOut();
      } else {
        handleCloseModalMultidelete();
        Swal.fire({
          icon: "error",
          title: res.data.message ? res.data.message : res.statusText,
          text: "",
        });
        console.log(
          `error deleteSelectedJobs:`,
          res.data.message ? res.data.message : res.status
        );
      }
      setloadingbuttondelete(false);
    });
  };

  // Snack Bar
  const vertical = "top";
  const horizontal = "right";
  const [openSnack, setOpenSnack] = useState(false);

  const handleClickSnack = () => {
    setOpenSnack(true);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnack(false);
  };

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [data, setData] = useState({ total: 0 });

  React.useEffect(() => {
    getData(0, rowsPerPage);
  }, []);

  const getData = async (nowPage, nowRowsPerPage) => {
    setSelected([]); // Clear selected row

    setLoading(true);

    const role = dataAccessPermission("OPTION");

    var nowPages = nowPage + 1;

    let qString = `?page=${nowPages}&perpage=${nowRowsPerPage}`;
    qString += `&UserRole=${role}`;
    if (searchInput) qString = qString + "&KeyWord=" + searchInput;

    await getJobWithProducts(qString).then((res) => {
      if (res && res?.status === 200) {
        // setDataProduct(res.data);

        // For paginate
        setDataProduct(res.data.data);
        setData(res.data);
      } else if (res?.status === 401) {
        signOut();
      } else if (res === undefined) {
        Swal.fire({
          icon: "error",
          title: "Database connection failed",
          text: "Please contact administrator",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: res?.data.message,
          text: res?.data.error,
        });
      }
      setLoading(false);
    });
  };

  const getAllData = async () => {
    const role = dataAccessPermission("OWNER");

    let qString = `?UserRole=${role}`;

    var result = [];

    await getAllProducts(qString).then((res) => {
      if (res && res.status === 200) {
        result = res.data;
      } else if (res.status === 401) {
        signOut();
      } else {
        Swal.fire({
          icon: "error",
          title: res.data.message,
          text: res.data.error,
        });
      }
    });
    return result;
  };

  const checkFileName = (name) => {
    return name.toLowerCase().includes("xlsx");
  };

  //////////////// setting RowsPerPage ////////////////
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getData(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getData(0, event.target.value);
  };

  //////////////// Import excel files ////////////////

  const handleFile = async (e) => {
    const myFile = e.target.files[0];

    if (!myFile) return;

    if (!checkFileName(myFile.name)) {
      Swal.fire({
        icon: "warning",
        text: "Invalid File Type!",
        position: "center",
        customClass: {
          container: "my-swal-container", // Apply custom class for container
        },
      });
      return;
    }

    setFile(myFile);
    setFileName(myFile.name);
    setErrorMsg("");
    setSumErrorMsg("");
  };

  const uploadExcelFile = async () => {
    var formData = new FormData();

    if (fileRef) {
      formData.append("file", fileRef.current.files[0]);
      formData.append("fname", fileName);
      formData.append("user_id", userData.userID);
      formData.append("uname", userData.name);
    }

    let updSuccess = false;
    let fileCreated = {};
    await uploadProductFile(formData).then((res) => {
      if (res && res.status === 200 && res.data.success === true) {
        updSuccess = true;
        fileCreated = res.data;
      } else if (res.status === 401) {
        handleRemove();
        handleClose(); // close upload modal
        setloadingbutton(false);
        signOut();
      } else {
        Swal.fire({
          icon: "error",
          // text: res.data.message,
          title: "Upload file failed!",
          customClass: {
            container: "my-swal-container", // Apply custom class for container
          },
        });
        console.log(`error uploadProductFile:`, res.data.err);
        handleRemove();
        handleClose(); // close upload modal
        setloadingbutton(false);
      }
    });

    if (updSuccess) {
      // Call InsertExcel API for insert data to BigQuery ---------
      const dataForm = {
        file_name: fileName,
        created: moment(fileCreated.created).format("YYYY-MM-DD HH:mm:ss"),
        updated: moment(fileCreated.updated).format("YYYY-MM-DD HH:mm:ss"),
      };

      await importProduct(dataForm).then((res) => {
        if (res && res.status === 200 && res.data.success === true) {
          Swal.fire({
            position: "center",
            icon: "success",
            // title: `Upload successfully`,
            title: t("resource.success.upload"),
            showConfirmButton: false,
            customClass: {
              container: "my-swal-container", // Apply custom class for container
            },
          });
        } else if (res.status === 401) {
          handleRemove();
          handleClose(); // close upload modal
          setloadingbutton(false);
          signOut();
        } else {
          // Error message
          Swal.fire({
            icon: "error",
            // title: "Oops...",
            title: res.data.message,
            text: res.data.err_data,
            // text: t("resource.err.insert"),
            customClass: {
              container: "my-swal-container", // Apply custom class for container
            },
          });
          console.log(`error importProduct:`, res);
        }
        handleRemove();
        handleClose(); // close upload modal
        setloadingbutton(false);
      });
      // End insert -----------------------------------------------

      setPage(0);
      getData(0, rowsPerPage);
    }
  };

  const handleRemove = (jsonData) => {
    setFile(null);
    setFileName(null);

    fileRef.current.value = "";
  };

  const handleClickSearch = () => {
    setPage(0);
    getData(0, rowsPerPage);
    addLog("Job", "Search", null);
  };

  // For custom excel header
  const customHeaderExport = [
    {
      customID: "Code",
      customProduct: "Product",
      customUoM: "UoM",
      customDesc: "Description",
      customModel: "Model or Type",
      customMatCost: "Material labor cost",
      customPrice: "Price",
      customPriceHome: "HomePro Price",
      customPriceThai: "Thai Watsadu Price",
      customPriceBoon: "Boonthavorn Price",
      customPriceOth: "Other Price",
      customUrlHome: "HomePro Link",
      customUrlThai: "Thai Watsadu Link",
      customUrlBoon: "Boonthavorn Link",
      customUrlOth: "Other Link",
      customSearchOn: "Searched on",
    },
  ];

  const getUniqueMaterials = (data) => {
    const allMaterials = data.flatMap((group) => group.item_material);

    // Create a Map to ensure unique IDItem
    const materialMap = new Map();
    allMaterials.forEach((material) => {
      if (!materialMap.has(material.IDItem)) {
        materialMap.set(material.IDItem, material);
      }
    });

    // Return the unique materials as an array
    return Array.from(materialMap.values());
  };

  async function exportAll() {
    // Get all products
    const material = await getAllData();

    exportExcelCustomHeader(material, "ProductsList", customHeaderExport);

    setLoadingBtnExportAll(false);
    handleCloseConfirmExportAll();
  }

  function exportSelected() {
    // Filter selected jobs
    const selProduct = dataProduct.filter((group) =>
      selected.includes(group.GroupID)
    );
    // Filter only products (exclude jobs)
    const material = getUniqueMaterials(selProduct);

    exportExcelCustomHeader(
      material,
      "ProductsSelectedList",
      customHeaderExport
    );

    setSelected([]); // Clear selected row

    setLoadingBtnExport(false);
    handleCloseConfirmExport();
  }

  let NumberForm = new Intl.NumberFormat("th-TH", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  function CodeForm(id) {
    return String(id).padStart(5, "0"); // Pads the number to be 5 characters long
  }

  // Copy to clipboard
  const handleCopyClick = (textToCopy) => {
    navigator.clipboard.writeText(textToCopy).then(() => {
      setOpenSnack(true);
    });
  };

  return (
    <Box
      sx={{
        margin: "65px 0px 0px 0px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Snackbar
        open={openSnack}
        autoHideDuration={2000}
        onClose={handleCloseSnack}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        message={t("common.message.copy")}
      />

      {/*  ////////////////////////// Search Box ////////////////////////// */}
      <Box
        sx={{
          display: "flex",
          paddingBottom: "20px",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Box
            sx={{ width: { lg: "700px", md: "500px" }, display: "flex", mr: 2 }}
          >
            <TextField
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderColor: "white",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                },
              }}
              placeholder={t("product.txtbox.search")}
              size="middle"
              variant="outlined"
              InputProps={{
                style: {
                  borderRadius: "10px",
                  backgroundColor: "#F0F0F0",
                  paddingLeft: "15px",
                  fontSize: "medium",
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <IconButton
                    sx={{
                      visibility: searchInput ? "visible" : "hidden",
                    }}
                    onClick={handleClearSearchProduct}
                  >
                    <ClearIcon />
                  </IconButton>
                ),
              }}
              fullWidth
              value={searchInput}
              onChange={(e) => {
                setSearchInput(e.target.value);
              }}
            />
          </Box>

          <Box>
            <Button
              onClick={handleClickSearch}
              variant="contained"
              size="small"
              sx={styleGrayBtn}
            >
              {/* Search */}
              {t("common.button.search")}
            </Button>
          </Box>
        </Box>

        <Box>
          {selected.length > 0 ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Box sx={{ mr: 2 }}>
                  <Typography>
                    {t("product.text.sel")}
                    {selected.length}
                    {t("product.text.unit")}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", mr: 2 }}>
                  <Button
                    variant="contained"
                    size="small"
                    sx={styleGrayBtn}
                    startIcon={<SettingsIcon />}
                    onClick={handleOpenActionMenuSelected}
                  >
                    {t("common.button.action")}
                  </Button>
                  <StyledMenu
                    sx={{ mt: "45px" }}
                    id="menu-appbar"
                    anchorEl={anchorElActionSelected}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={Boolean(anchorElActionSelected)}
                    onClose={handleCloseActionMenuSelected}
                  >
                    {actionsSelected.map((action, index) => (
                      <StyledMenuItem key={index}>
                        <Grid
                          container
                          direction="row"
                          alignItems="center"
                          onClick={action.event}
                        >
                          <Grid item>{action.icon}</Grid>
                          <Grid item>
                            <Typography textAlign="center" marginX={0.5}>
                              {action.name}
                            </Typography>
                          </Grid>
                        </Grid>
                      </StyledMenuItem>
                    ))}
                  </StyledMenu>
                </Box>
              </Box>
            </>
          ) : (
            <>
              <Button
                variant="contained"
                size="small"
                sx={styleGrayBtn}
                startIcon={<SettingsIcon />}
                onClick={handleOpenActionMenu}
              >
                {t("common.button.action")}
              </Button>
              <StyledMenu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElAction}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElAction)}
                onClose={handleCloseActionMenu}
              >
                {actions.map((action, index) => (
                  <StyledMenuItem key={index}>
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      onClick={action.event}
                    >
                      <Grid item>{action.icon}</Grid>
                      <Grid item>
                        <Typography textAlign="center" marginX={0.5}>
                          {action.name}
                        </Typography>
                      </Grid>
                    </Grid>
                  </StyledMenuItem>
                ))}
              </StyledMenu>
            </>
          )}
        </Box>
      </Box>

      {/* ////////////////// New table with sorting and collpase /////////////// */}
      <TableContainer sx={{ maxHeight: 680 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell
                padding="checkbox"
                sx={{
                  backgroundColor: "#c4e6ff",
                }}
              >
                <Checkbox
                  // checked={
                  //   selected.length === dataProduct.length &&
                  //   dataProduct.length !== 0
                  // }
                  // onChange={() =>
                  //   setSelected(
                  //     selected.length === dataProduct.length
                  //       ? []
                  //       : dataProduct.map((item) => item.GroupID)
                  //   )
                  // }
                  checked={
                    userData.department === "IT"
                      ? selected.length === dataProduct.length &&
                        dataProduct.length !== 0
                      : dataProduct.filter(
                          (item) => item.UserRole === userData.department
                        ).length > 0 &&
                        selected.length ===
                          dataProduct.filter(
                            (item) => item.UserRole === userData.department
                          ).length
                  }
                  onChange={() => {
                    userData.department === "IT"
                      ? setSelected(
                          selected.length === dataProduct.length
                            ? []
                            : dataProduct.map((item) => item.GroupID)
                        )
                      : // For other role, not IT, can select only their department data
                        setSelected(
                          selected.length ===
                            dataProduct.filter(
                              (item) => item.UserRole === userData.department
                            ).length
                            ? []
                            : dataProduct
                                .filter(
                                  (item) =>
                                    item.UserRole === userData.department
                                )
                                .map((item) => item.GroupID)
                        );

                    // const selectable = dataProduct.filter(
                    //   (item) => item.UserRole === userData.department
                    // );
                    // setSelected(
                    //   selected.length === selectable.length
                    //     ? []
                    //     : selectable.map((item) => item.GroupID)
                    // );
                  }}
                />
              </TableCell>
              {headCells.map((headCell, index) => (
                <TableCell
                  key={index}
                  align={headCell.numeric ? "right" : "left"}
                  padding={headCell.disablePadding ? "none" : "normal"}
                  sx={{
                    backgroundColor: "#c4e6ff",
                    padding: "10px",
                    fontWeight: "bold",
                    color: "#1D589D",
                  }}
                  sortDirection={orderBy === headCell.sortKey ? order : false}
                >
                  {headCell.sortKey !== null ? (
                    <TableSortLabel
                      active={orderBy === headCell.sortKey}
                      direction={orderBy === headCell.sortKey ? order : "asc"}
                      onClick={() => handleRequestSort(headCell.sortKey)}
                    >
                      {headCell.label}
                    </TableSortLabel>
                  ) : (
                    headCell.label
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={7}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress color="inherit" />
                  </Box>
                </TableCell>
              </TableRow>
            ) : sortedData.length > 0 ? (
              sortedData.map((row, index) => (
                <React.Fragment key={index}>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selected.includes(row.GroupID)}
                        onChange={() => handleSelect(row.GroupID)}
                        // onChange={() => handleSelect(row.GroupID, row.UserRole)}
                        disabled={
                          userData.department === "IT"
                            ? false
                            : row.UserRole === userData.department
                            ? false
                            : true
                        }
                      />
                    </TableCell>
                    <TableCell
                      width={80}
                      style={{
                        maxWidth: "80px",
                        minWidth: "50px",
                      }}
                    >
                      {CodeForm(row.GroupID)}
                    </TableCell>
                    <TableCell
                      scope="row"
                      padding="none"
                      width={350}
                      style={{
                        maxWidth: "500px",
                        minWidth: "400px",
                      }}
                    >
                      <Typography variant="body1">{row.GroupName}</Typography>
                    </TableCell>
                    <TableCell width={80} style={{ maxWidth: "100px" }}>
                      {row.UoMGroup}
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        minWidth: "200px",
                        maxWidth: "300px",
                      }}
                    >
                      <Typography variant="body1">
                        {row.GroupDescribe}
                      </Typography>
                    </TableCell>
                    <TableCell
                      align="right"
                      style={{
                        minWidth: "50",
                        maxWidth: "100px",
                      }}
                    >
                      {NumberForm.format(row.LaborCost)}
                    </TableCell>

                    <TableCell width={60} style={{ maxWidth: "80px" }}>
                      {row.item_material.length > 0 ? (
                        <IconButton
                          onClick={() => handleRowToggle(row.GroupID)}
                        >
                          {openRow === row.GroupID ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </IconButton>
                      ) : (
                        ""
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={7} style={{ padding: 0 }}>
                      <Collapse
                        in={openRow === row.GroupID}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box sx={{ marginTop: 0 }}>
                          <Table size="small" aria-label="purchases">
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  padding="checkbox"
                                  sx={{ backgroundColor: "#c4e6ff" }}
                                  style={{
                                    borderBottom: "2px solid gray",
                                    borderTop: "none",
                                  }}
                                ></TableCell>

                                {subHeadCells.map((subHead, index) => (
                                  <TableCell
                                    key={index}
                                    align={subHead.numeric ? "right" : "left"}
                                    padding={
                                      subHead.disablePadding ? "none" : "normal"
                                    }
                                    sx={{
                                      color: "#1D589D",
                                      fontWeight: "bold",
                                      padding: "10px",
                                      backgroundColor: "#c4e6ff",
                                    }}
                                    style={{
                                      borderBottom: "2px solid gray",
                                      borderTop: "none",
                                    }}
                                  >
                                    {subHead.label}
                                  </TableCell>
                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {row.item_material.map((materialRow, index) => (
                                <TableRow key={index}>
                                  <TableCell padding="checkbox"></TableCell>
                                  <TableCell
                                    width={80}
                                    style={{
                                      maxWidth: "80px",
                                      minWidth: "50px",
                                    }}
                                  >
                                    {CodeForm(materialRow.IDItem)}
                                  </TableCell>
                                  <TableCell
                                    scope="row"
                                    padding="none"
                                    width={350}
                                    style={{
                                      minWidth: "400px",
                                      maxWidth: "500px",
                                    }}
                                  >
                                    <Typography variant="string">
                                      {materialRow.itemname}
                                    </Typography>
                                  </TableCell>
                                  <TableCell
                                    width={80}
                                    style={{ maxWidth: "100px" }}
                                  >
                                    {materialRow.UoMItem}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    style={{
                                      minWidth: "150px",
                                    }}
                                  >
                                    <Typography variant="body2">
                                      {materialRow.ItemDescription}
                                    </Typography>
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    style={{
                                      minWidth: "50px",
                                      maxWidth: "120px",
                                      whiteSpace: "normal",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    <Typography variant="body2">
                                      {materialRow.model}
                                    </Typography>
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    style={{
                                      minWidth: "50px",
                                      maxWidth: "100px",
                                    }}
                                  >
                                    {NumberForm.format(
                                      materialRow.MaterialLaborCost
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    style={{
                                      minWidth: "50px",
                                      maxWidth: "100px",
                                    }}
                                  >
                                    {NumberForm.format(
                                      materialRow.material_Price
                                    )}
                                  </TableCell>

                                  <TableCell
                                    align="right"
                                    style={{
                                      minWidth: "50px",
                                      maxWidth: "100px",
                                    }}
                                  >
                                    {NumberForm.format(
                                      materialRow.matPriceHome
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    style={{
                                      minWidth: "50px",
                                      maxWidth: "100px",
                                    }}
                                  >
                                    {NumberForm.format(
                                      materialRow.matPriceThai
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    style={{
                                      minWidth: "50px",
                                      maxWidth: "100px",
                                    }}
                                  >
                                    {NumberForm.format(
                                      materialRow.matPriceBoon
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    style={{
                                      minWidth: "50px",
                                      maxWidth: "100px",
                                    }}
                                  >
                                    {NumberForm.format(materialRow.matPriceOth)}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      minWidth: "50px",
                                      maxWidth: "150px",
                                    }}
                                    align="left"
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      {materialRow.urlHome ? (
                                        <Button
                                          variant="text"
                                          style={{
                                            textTransform: "none",
                                            textAlign: "left",
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            padding: 0,
                                          }}
                                          size="small"
                                        >
                                          <Typography
                                            style={{
                                              whiteSpace: "normal",
                                              wordBreak: "break-word",
                                            }}
                                            sx={{
                                              display: "-webkit-box",
                                              WebkitBoxOrient: "vertical",
                                              overflow: "hidden",
                                              WebkitLineClamp: 1, // Limits to 1 lines
                                              textOverflow: "ellipsis",
                                              fontSize: "12px",
                                            }}
                                          >
                                            <a
                                              href={materialRow.urlHome}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              style={{
                                                textDecoration: "none",
                                                color: "inherit",
                                              }}
                                            >
                                              HomePro
                                            </a>
                                          </Typography>
                                        </Button>
                                      ) : (
                                        ""
                                      )}

                                      {materialRow.urlThai ? (
                                        <Button
                                          variant="text"
                                          style={{
                                            textTransform: "none",
                                            textAlign: "left",
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            padding: 0,
                                          }}
                                          size="small"
                                        >
                                          <Typography
                                            style={{
                                              whiteSpace: "normal",
                                              wordBreak: "break-word",
                                            }}
                                            sx={{
                                              display: "-webkit-box",
                                              WebkitBoxOrient: "vertical",
                                              overflow: "hidden",
                                              WebkitLineClamp: 1, // Limits to 1 lines
                                              textOverflow: "ellipsis",
                                              fontSize: "12px",
                                            }}
                                          >
                                            <a
                                              href={materialRow.urlThai}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              style={{
                                                textDecoration: "none",
                                                color: "inherit",
                                              }}
                                            >
                                              Thai watsadu
                                            </a>
                                          </Typography>
                                        </Button>
                                      ) : (
                                        ""
                                      )}

                                      {materialRow.urlBoon ? (
                                        <Button
                                          variant="text"
                                          style={{
                                            textTransform: "none",
                                            textAlign: "left",
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            padding: 0,
                                          }}
                                          size="small"
                                        >
                                          <Typography
                                            style={{
                                              whiteSpace: "normal",
                                              wordBreak: "break-word",
                                            }}
                                            sx={{
                                              display: "-webkit-box",
                                              WebkitBoxOrient: "vertical",
                                              overflow: "hidden",
                                              WebkitLineClamp: 1, // Limits to 1 lines
                                              textOverflow: "ellipsis",
                                              fontSize: "12px",
                                            }}
                                          >
                                            <a
                                              href={materialRow.urlBoon}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              style={{
                                                textDecoration: "none",
                                                color: "inherit",
                                              }}
                                            >
                                              Boonthavorn
                                            </a>
                                          </Typography>
                                        </Button>
                                      ) : (
                                        ""
                                      )}
                                      {materialRow.urlOth ? (
                                        materialRow.urlOth.startsWith(
                                          "https://"
                                        ) ? (
                                          <Button
                                            variant="text"
                                            style={{
                                              textTransform: "none",
                                              textAlign: "left",
                                              display: "flex",
                                              justifyContent: "flex-start",
                                              padding: 0,
                                            }}
                                            size="small"
                                          >
                                            <Typography
                                              style={{
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                              }}
                                              sx={{
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                                WebkitLineClamp: 1, // Limits to 1 lines
                                                textOverflow: "ellipsis",
                                                fontSize: "12px",
                                              }}
                                            >
                                              <a
                                                href={materialRow.urlOth}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                  textDecoration: "none",
                                                  color: "inherit",
                                                }}
                                              >
                                                Other
                                              </a>
                                            </Typography>
                                          </Button>
                                        ) : (
                                          <div>
                                            <Button
                                              variant="text"
                                              style={{
                                                textTransform: "none",
                                                textAlign: "left",
                                                display: "flex",
                                                justifyContent: "flex-start",
                                                padding: 0,
                                              }}
                                              size="small"
                                              onClick={() => {
                                                handleCopyClick(
                                                  materialRow.urlOth
                                                );
                                              }}
                                            >
                                              <Typography
                                                style={{
                                                  whiteSpace: "normal",
                                                  wordBreak: "break-word",
                                                }}
                                                sx={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  overflow: "hidden",
                                                  WebkitLineClamp: 1, // Limits to 1 lines
                                                  textOverflow: "ellipsis",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                Other
                                              </Typography>
                                            </Button>
                                          </div>
                                        )
                                      ) : (
                                        ""
                                      )}
                                      {materialRow.urlOth2 ? (
                                        materialRow.urlOth2.startsWith(
                                          "https://"
                                        ) ? (
                                          <Button
                                            variant="text"
                                            style={{
                                              textTransform: "none",
                                              textAlign: "left",
                                              display: "flex",
                                              justifyContent: "flex-start",
                                              padding: 0,
                                            }}
                                            size="small"
                                          >
                                            <Typography
                                              style={{
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                              }}
                                              sx={{
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                                WebkitLineClamp: 1, // Limits to 1 lines
                                                textOverflow: "ellipsis",
                                                fontSize: "12px",
                                              }}
                                            >
                                              <a
                                                href={materialRow.urlOth2}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                  textDecoration: "none",
                                                  color: "inherit",
                                                }}
                                              >
                                                Other2
                                              </a>
                                            </Typography>
                                          </Button>
                                        ) : (
                                          <div>
                                            <Button
                                              variant="text"
                                              style={{
                                                textTransform: "none",
                                                textAlign: "left",
                                                display: "flex",
                                                justifyContent: "flex-start",
                                                padding: 0,
                                              }}
                                              size="small"
                                              onClick={() => {
                                                handleCopyClick(
                                                  materialRow.urlOth2
                                                );
                                              }}
                                            >
                                              <Typography
                                                style={{
                                                  whiteSpace: "normal",
                                                  wordBreak: "break-word",
                                                }}
                                                sx={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  overflow: "hidden",
                                                  WebkitLineClamp: 1, // Limits to 1 lines
                                                  textOverflow: "ellipsis",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                Other2
                                              </Typography>
                                            </Button>
                                          </div>
                                        )
                                      ) : (
                                        ""
                                      )}
                                    </Box>
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      minWidth: "100px",
                                      maxWidth: "120px",
                                    }}
                                    align="left"
                                  >
                                    <Typography variant="body2">
                                      {materialRow.last_updated
                                        ? moment(
                                            materialRow.last_updated
                                          ).format("YYYY-MM-DD HH:mm:ss")
                                        : ""}
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7}>
                  <Box
                    style={{ display: "flex", justifyContent: "center" }}
                  ></Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          {/* Original */}
          {/* <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[
                  10, 25, 50, 100,
                  // { label: "All", value: -1 },
                ]}
                colSpan={7}
                count={data.total}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter> */}
        </Table>
      </TableContainer>
      <TableFooter align="right">
        <TableRow>
          <TablePagination
            rowsPerPageOptions={[
              10, 25, 50, 100,
              // { label: "All", value: -1 },
            ]}
            // colSpan={7}
            count={data.total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </TableRow>
      </TableFooter>

      {/* /////////// Modal confirm Delete form /////////// */}
      <Modal open={openModaldelete}>
        <Box sx={styleModaldelete}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography marginTop={1} variant="h5" component="h2">
              Delete product
            </Typography>
            <IconButton size="large" onClick={handleCloseModaldelete}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
          <Typography
            sx={{ mt: 3, color: "#616161" }}
            fontSize={14}
            fontWeight={300}
          >
            Do you want to confirm Delete product ?
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "5rem",
            }}
          >
            <LoadingButton
              color="error"
              loading={loadingbuttondelete}
              loadingPosition="start"
              startIcon={<DeleteIcon />}
              variant="contained"
              size="large"
            >
              <span>Delete</span>
            </LoadingButton>
            <Button
              style={{ marginLeft: 12 }}
              variant="outlined"
              size="middle"
              color="inherit"
              onClick={handleCloseModaldelete}
            >
              <Typography fontSize={14}>cancel</Typography>
            </Button>
          </Box>
        </Box>
      </Modal>
      {/* /////////// Modal confirm multi files Delete /////////// */}
      <Modal open={openModalMultidelete}>
        <Box sx={styleModaldelete}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography marginTop={1} variant="h5" component="h2">
              {t("product.popup.delete.header")}
            </Typography>
            <IconButton size="large" onClick={handleCloseModalMultidelete}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
          <Typography
            sx={{ mt: 3, color: "#616161" }}
            fontSize={14}
            fontWeight={300}
          >
            {t("product.popup.delete.txt1")}
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "5rem",
            }}
          >
            <LoadingButton
              color="error"
              onClick={handleClickModalMultidelete}
              loading={loadingbuttondelete}
              loadingPosition="start"
              startIcon={<DeleteIcon />}
              variant="contained"
              size="medium"
            >
              {t("common.button.del")}
            </LoadingButton>
            <Button
              style={{ marginLeft: 12 }}
              variant="outlined"
              size="medium"
              color="inherit"
              onClick={handleCloseModalMultidelete}
            >
              {t("common.button.cancel")}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/*//////////////// Modal popup for Import files ////////////////*/}
      <Modal open={open}>
        <Box sx={style}>
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Typography variant="h5">Import product file</Typography>
          </Box>
          <Box
            sx={{
              mt: 4,
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box>
                {fileName && (
                  <Typography
                    style={{
                      fontSize: "14px",
                      color: "#357a38",
                      fontWeight: 400,
                    }}
                  >
                    selected Excel file already!!
                  </Typography>
                )}
                {!fileName && (
                  <Typography style={{ fontSize: "14px", color: "#9E9E9E" }}>
                    Please select Excel file
                  </Typography>
                )}
              </Box>
              <Box>
                <input
                  type="file"
                  accept=".xlsx"
                  multiple={false}
                  onChange={(e) => handleFile(e)}
                  ref={fileRef}
                />

                {fileName && (
                  <ClearIcon
                    onClick={() => {
                      handleRemove();
                    }}
                  />
                )}
              </Box>
            </Box>
          </Box>

          {fileName && (
            <Box
              sx={{
                mt: 3,
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <Typography fontSize={14}>
                <span style={{ color: "#1565c0", fontWeight: 500 }}>
                  {t("resource.popup.upload.txt4")}{" "}
                </span>
                {fileName ? (
                  fileName
                ) : (
                  <span style={{ color: "#c62828" }}>"กรุณาระบุ ชื่อไฟล์"</span>
                )}
              </Typography>
            </Box>
          )}

          <br />

          <Box
            sx={{
              mt: 5,
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography color="error" variant="h6" fontWeight={400}>
                {errorMsg}
              </Typography>
            </Box>
            <Box>
              <LoadingButton
                onClick={handleClickModal}
                loading={loadingbutton}
                loadingPosition="start"
                startIcon={<SaveIcon />}
                variant="contained"
                size="small"
                disabled={fileName ? false : true}
              >
                <span>Upload File</span>
              </LoadingButton>

              <Button
                style={{ marginLeft: 12 }}
                variant="outlined"
                size="middle"
                color="inherit"
                onClick={() => {
                  handleClose();
                  handleRemove();
                }}
              >
                <Typography fontSize={14}>cancel</Typography>
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* /////////// Modal confirm Export all /////////// */}
      <Modal open={openConfirmExportAll}>
        <Box sx={style}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography marginTop={1} variant="h5" component="h2">
              {t("product.popup.exportAll.header")}
            </Typography>
            <IconButton size="large" onClick={handleCloseConfirmExportAll}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
          <Typography
            sx={{ mt: 3, color: "#616161" }}
            fontSize={14}
            fontWeight={300}
          >
            {t("product.popup.exportAll.txt1")}
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "5rem",
            }}
          >
            <LoadingButton
              onClick={handleClickModalExportAll}
              loading={loadingBtnExportAll}
              loadingPosition="start"
              startIcon={<FileUploadOutlinedIcon />}
              variant="contained"
              size="small"
            >
              {t("product.button.export")}
            </LoadingButton>
            <Button
              style={{ marginLeft: 12 }}
              variant="outlined"
              size="middle"
              color="inherit"
              onClick={handleCloseConfirmExportAll}
            >
              {t("common.button.cancel")}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* /////////// Modal confirm Export selected row /////////// */}
      <Modal open={openConfirmExport}>
        <Box sx={style}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography marginTop={1} variant="h5" component="h2">
              {t("product.popup.export.header")}
            </Typography>
            <IconButton size="large" onClick={handleCloseConfirmExport}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
          <Typography
            sx={{ mt: 3, color: "#616161" }}
            fontSize={14}
            fontWeight={300}
          >
            {t("product.popup.export.txt1")}
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "5rem",
            }}
          >
            <LoadingButton
              onClick={handleClickModalExport}
              loading={loadingBtnExport}
              loadingPosition="start"
              startIcon={<FileUploadOutlinedIcon />}
              variant="contained"
              size="small"
            >
              {t("product.button.export")}
            </LoadingButton>
            <Button
              style={{ marginLeft: 12 }}
              variant="outlined"
              size="middle"
              color="inherit"
              onClick={handleCloseConfirmExport}
            >
              {t("common.button.cancel")}
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
